module.exports = __webpack_public_path__ + "img/delete.09014502.png";